
import React from "react";
import './ScrollHelper.css';
import Constants from "utilities/js/Constants";

const downArrow = Constants.ICON_DOWN_ARROW;

class ScrollHelper extends React.Component {

    constructor(props){
        super(props);
        this.state = { 
            direction: this.props.direction ? this.props.direction.toLowerCase() : 'down',
            fadeScrollAssistant: false,
            showScrollAssistant: true,
            float: this.props.float
        };

        this.scrollAssistantRef = React.createRef();
    }

    componentDidMount(){
        this.setState({mounted: true})
        
        let parentElement = this.scrollAssistantRef.current.parentElement;
        parentElement.addEventListener('scroll', this.removeScrollAssistant.bind(this), { passive: true })
    }

    removeScrollAssistant(){
        let parentElement = this.scrollAssistantRef.current.parentElement;
        this.setState({fadeScrollAssistant: true})

        setTimeout(()=>{
            this.setState({'showScrollAssistant': false})
            parentElement.removeEventListener('scroll', this.removeScrollAssistant.bind(this), { passive: true })
        }, 1000)
    }

    
    toggleScrollAssistant(){
        let parentElement = this.scrollAssistantRef.current.parentElement;

        if(parentElement.clientHeight + parentElement.scrollTop >= parentElement.scrollHeight - 10){
            this.setState({fadeScrollAssistant: true})
            this.setState({'showScrollAssistant': false})
        }else{
            if(!this.state.showScrollAssistant){
                this.setState({showScrollAssistant: true, fadeScrollAssistant: false});
            }
        }
    }

    get scrollAssistantClass(){
        let className = 'scroll-assistant';
        if(this.state.float){
            className = 'scroll-assistant-float';
        }
        if(this.state.fadeScrollAssistant){
            return className += " scroll-assistant-fade scroll-assistant-" + this.state.direction;
        }else{
            return className += " scroll-assistant-" + this.state.direction;
        }
    }

    

    get scrollHelperDisplay(){
        if(this.state.mounted === true && this.state.showScrollAssistant){
            if(this.state.direction === 'down'){
                let parentElement = this.scrollAssistantRef.current.parentElement;
                if(parentElement.scrollHeight > parentElement.clientHeight){
                    return(  
                        <div className={this.scrollAssistantClass}>
                            <img src={downArrow} className="scroll-assistant-arrow-icon"></img>
                        </div>
                    )
                }
            }else if(this.state.direction === 'right'){
                let parentElement = this.scrollAssistantRef.current.parentElement;
                if(parentElement.scrollWidth > parentElement.clientWidth){
                    return(  
                        <div className={this.scrollAssistantClass}>
                            <img src={downArrow} className="scroll-assistant-arrow-icon"></img>
                        </div>
                    )
                }
            }
        }else if(!this.state.showScrollAssistant){
            return (                
                <div className="scroll-assistant-spacer"></div>
            )
        }
    }
    
    render(){
        return (
            <>                
                <div ref={this.scrollAssistantRef}></div>
                {this.scrollHelperDisplay}
            </>
        );
    }
}

export default ScrollHelper;

